import { memo } from "react";
import type { NavigationMenuContentProps as RadixNavigationMenuContentProps } from "@radix-ui/react-navigation-menu";
import { NavigationMenuContent } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";

export type NavigationContentProps = {} & RadixNavigationMenuContentProps;

const NavigationContent = ({
  className,
  children,
  ...rest
}: NavigationContentProps) => {
  return (
    <NavigationMenuContent
      className={cn(
        "!w-[100vw] border-t-1 border-[#E9F1FF] !bg-[linear-gradient(to_right,#fff_50%,#eaeffb_50%)]",
        className
      )}
      {...rest}
    >
      <div className="container mx-auto">{children}</div>
    </NavigationMenuContent>
  );
};

export default memo(NavigationContent);
